export { default } from "./inbox/Inbox";
export type { InboxProps } from "./inbox/Inbox";
